import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AuthProvider, useAuth, homeForRole } from '../portal/AuthContext';
import PortalLogin from '../portal/PortalLogin';
import WebmasterPortal from '../portal/WebmasterPortal';
import OwnerPortal from '../portal/OwnerPortal';
import AcceptInvite from '../portal/AcceptInvite';
import '../portal/Portal.css';

/**
 * Everything under /portal. The whole tree sits inside one AuthProvider so the
 * session is fetched once, not per screen.
 */
export default function Portal() {
  return (
    <AuthProvider>
      <Switch>
        <Route path="/portal/invite/:token" component={AcceptInvite} />

        <Route path="/portal/webmaster">
          <Protected roles={['webmaster']}>
            <WebmasterPortal />
          </Protected>
        </Route>

        <Route path="/portal/owner">
          {/* The webmaster can open the owner's view to reproduce a problem. */}
          <Protected roles={['owner', 'webmaster']}>
            <OwnerPortal />
          </Protected>
        </Route>

        <Route path="/portal" exact component={PortalLogin} />

        <Redirect to="/portal" />
      </Switch>
    </AuthProvider>
  );
}

function Protected({ roles, children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="pt-app">
        <div className="pt-loading">Loading your portal…</div>
      </div>
    );
  }

  if (!user) {
    return <Redirect to="/portal" />;
  }

  if (roles.indexOf(user.role) === -1) {
    return <Redirect to={homeForRole(user.role)} />;
  }

  return children;
}
